import { render, staticRenderFns } from "./Engineering.vue?vue&type=template&id=284eac64&scoped=true"
import script from "./Engineering.vue?vue&type=script&lang=js"
export * from "./Engineering.vue?vue&type=script&lang=js"
import style0 from "./Engineering.vue?vue&type=style&index=0&id=284eac64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284eac64",
  null
  
)

export default component.exports